@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.link,
.icon {
  display: inline-block
}

.mobileOnly {
  @include desktop {
    display: none;
  }
}

.link {
  margin: 0 0.5em;

  @include mobile {
    margin-left: 0;
    margin-right: 0;
  }

  .button {
    @include mobile {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.button {
  border-radius: 0;
  transition: 25ms ease-out;
  padding: 0.5em 0.5em;
}

.icon svg {
  width: 2.5em;
  height: 2rem;
  vertical-align: top
}

.icon svg:hover {
  fill: #888888;
}

.small svg {
  margin: 0;
  vertical-align: middle
}

/* Non solid icons get a stroke */
.icon {
  stroke: $grey-light;
  fill: none
}

/* Solid icons get a fill */
.solid,
.solidcircle {
  fill: $grey;
  stroke: none;
}